// web/src/components/RecActions.tsx
import { useState } from "react";

export type ActionStatus = "snoozed" | "done" | "dismissed";

export interface RecActionsProps {
  onAction: (input: { status: ActionStatus; snooze_days?: 7 | 14 }) => Promise<void>;
  disabled?: boolean;
}

export function RecActions({ onAction, disabled }: RecActionsProps) {
  const [busy, setBusy] = useState<string | null>(null);

  async function run(label: string, payload: Parameters<RecActionsProps["onAction"]>[0]) {
    setBusy(label);
    try { await onAction(payload); }
    finally { setBusy(null); }
  }

  return (
    <div style={{ display: "flex", gap: 6, fontSize: 11 }}>
      <button
        type="button"
        disabled={disabled || busy !== null}
        onClick={() => run("snooze7", { status: "snoozed", snooze_days: 7 })}
      >
        {busy === "snooze7" ? "…" : "Snooze 7d"}
      </button>
      <button
        type="button"
        disabled={disabled || busy !== null}
        onClick={() => run("snooze14", { status: "snoozed", snooze_days: 14 })}
      >
        {busy === "snooze14" ? "…" : "Snooze 14d"}
      </button>
      <button
        type="button"
        disabled={disabled || busy !== null}
        onClick={() => run("done", { status: "done" })}
      >
        {busy === "done" ? "…" : "Mark done"}
      </button>
      <button
        type="button"
        disabled={disabled || busy !== null}
        onClick={() => run("dismiss", { status: "dismissed" })}
      >
        {busy === "dismiss" ? "…" : "Dismiss"}
      </button>
    </div>
  );
}
